import React from 'react';
import useErrorStore from '../../../stores/errorStore';
var ErrorScreen = function () {
    var error = useErrorStore().error;
    return (React.createElement("div", { className: "rounded-3xl mx-2 mt-30 px-12 pb-8 pt-4 bg-backgroundColor my-2 flex flex-col h-full justify-center" },
        React.createElement("div", { className: "flex flex-col gap-y-4 items-center justify-center" },
            React.createElement("span", { className: "font-medium text-center w-full text-gray-600 text-lg" }, error))));
};
export default ErrorScreen;
